
import { defineComponent, ref, reactive, inject, onMounted } from "vue";
import { genjinList, getConstructors } from "@/api/shenghuiHttp";

export default defineComponent({
    name: "FollowRecord",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["跟进记录"]);

        const headClass = inject("headClass");
        const loading = ref(false);
        const tableData = ref([] as any[]);
        const total = ref(0);
        const dateRange = ref([] as any);
        const pageSize = ref(10);
        const currentPage = ref(1);
        const staffList = ref([] as any[]);
        const searchParams = reactive({ o_id: "", car_code: "", maturity_type: "" });

        const getTableData = (): void => {
            loading.value = true;
            const data: any = {
                page: currentPage.value,
                pagesize: pageSize.value,
            };
            if (dateRange.value && dateRange.value.length === 2) {
                data.start_time = Math.floor(dateRange.value[0].getTime() / 1000);
                data.end_time = Math.floor(dateRange.value[1].getTime() / 1000);
            }
            if (searchParams.o_id) data.o_id = searchParams.o_id;
            if (searchParams.car_code) data.car_code = searchParams.car_code;
            if (searchParams.maturity_type) data.maturity_type = searchParams.maturity_type;
            genjinList(data).then((res: any) => {
                tableData.value = res?.content?.list || [];
                total.value = res?.content?.count || 0;
                loading.value = false;
            }).catch(() => {
                loading.value = false;
            });
        };

        const handleSizeChange = (size: number) => { pageSize.value = size; currentPage.value = 1; getTableData(); };
        const handleCurrentChange = (page: number) => { currentPage.value = page; getTableData(); };

        onMounted(() => {
            getConstructors({}).then((res: any) => {
                staffList.value = res?.content?.staff || [];
            });
            getTableData();
        });

        return { loading, headClass, tableData, total, dateRange, pageSize, currentPage, staffList, searchParams, getTableData, handleSizeChange, handleCurrentChange };
    },
});
